var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import AlbumRow from "./AlbumRow";
import * as uuid from 'uuid';
import { errorToString } from "bpm-client-api";
import * as toastr from 'toastr';
export var ManagedAlbumRow = function (props) {
    var loadingToken = React.useRef();
    var _a = React.useState(true), loading = _a[0], setLoading = _a[1];
    var _b = React.useState(), packages = _b[0], setPackages = _b[1];
    // paging 
    var _c = React.useState(false), forceToggle = _c[0], setForceToggle = _c[1];
    var _d = React.useState(0), skip = _d[0], setLimit = _d[1];
    var _e = React.useState(1), page = _e[0], setPage = _e[1];
    // REFS
    React.useEffect(function () {
        loadingToken.current = uuid.v4();
        setLoading(true);
        props.apiFunc({ limit: (props.defaultLimit || 30), skip: skip }, loadingToken.current).then(function (_a) {
            var data = _a.data, pagination = _a.pagination, token = _a.token;
            if (loadingToken.current == token || !token) {
                if (skip > 0) {
                    setPackages({ data: ((packages === null || packages === void 0 ? void 0 : packages.data) || []).concat(data), paging: pagination });
                }
                else {
                    setPackages({ data: data, paging: pagination });
                }
                setLoading(false);
            }
        }).catch(function (err) {
            errorToString(err).forEach(function (err) { return toastr.error(err); });
        });
    }, [skip, forceToggle]);
    React.useEffect(function () {
        if (skip > 0)
            setLimit(0);
        else
            setForceToggle(!forceToggle);
    }, [props.hashToWatch]);
    return (React.createElement(AlbumRow, __assign({ soundPackages: packages === null || packages === void 0 ? void 0 : packages.data, paging: packages === null || packages === void 0 ? void 0 : packages.paging, loading: loading }, props, { onLoadMore: function (limitOrPage, force, isPaging) {
            if (!isPaging) {
                if (limitOrPage == skip && force) {
                    setForceToggle(!forceToggle);
                }
                else {
                    setLimit(limitOrPage);
                }
            }
            else {
                setPage(limitOrPage);
            }
        } })));
};
//# sourceMappingURL=ManagedAlbumRow.js.map